import { ApplicationRootState } from 'redux-core/types';
import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectAdminMember = (state: ApplicationRootState) =>
    state.admin.member || initialState;

export const selectMemberList = createSelector(
    selectAdminMember,
    (state) => state.list
);
